import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { createGlobalStyle } from 'styled-components';
import { Theme } from '../models/Theme';

// List of allowed html elements that can be targeted for styling
const accessibilityStyleKeys = ['Button', 'A', 'Input'];

const accessibilityStyles = {};
// build up key/component pairs based on accessibilityStyleKeys for mapping with styling
for (const key of accessibilityStyleKeys) {
    accessibilityStyles[key] = createGlobalStyle`
    ${key} {
        ${propStyles};
    }
`;
}

const AccessibilityWrapperStyled = styled<any, any>(
    'div',
    'accessibilityWrapperStyled',
    'accessibilityWrapper'
)`
    ${propStyles};
`;

AccessibilityWrapperStyled.defaultProps = {};

interface AccessibilityWrapperProps {
    theme?: Theme;
}

@observer
class AccessibilityWrapper extends React.Component<AccessibilityWrapperProps> {
    render() {
        const { children, theme } = this.props;
        return (
            <React.Fragment>
                {accessibilityStyleKeys.map(key => {
                    const GlobalStyleComponent = accessibilityStyles[key];
                    return <GlobalStyleComponent key={key} {...theme[key]} />;
                })}
                <AccessibilityWrapperStyled>
                    {children}
                </AccessibilityWrapperStyled>
            </React.Fragment>
        );
    }
}

export default withTheme(AccessibilityWrapper) as any;



// WEBPACK FOOTER //
// ./src/Components/AccessibilityWrapper.tsx